import React from 'react';
import { notificationApi } from '@bingads-webui-react/notification-center';
import { withI18nConsumer } from '@bingads-webui-react/i18n-context';
// eslint-disable-next-line
import { loadMap } from '@bingads-webui-campaign-legacy/dashboard-page/service/load-map';
import instrumentation from '@bingads-webui-campaign-legacy/instrumentation/index';

const BING_MAP_ERR_MSG = _TL_('We\'ve encountered an error while loading Bing Map SDK and cannot continue. Please check your network connection and try again, or contact Support for assistance.');

export const withBingMap = (WrappedComponent) => {
  const ComponentWithBingMap = React.lazy(() => loadMap()
    .then(() => ({
      default: WrappedComponent,
    })).catch((e) => {
      const scenario = instrumentation.loadBingMapScenario.create();
      const activity = scenario.loadBingMapError.create();
      activity.error(`Failed to load bing map SDK, exception: ${e}`);
      return {
        default: withI18nConsumer((props) => {
          notificationApi.showWarning(props.i18n.getString(BING_MAP_ERR_MSG));
          return <WrappedComponent {...props} />;
        }),
      };
    }));

  return props => <ComponentWithBingMap {...props} />;
};
